<!-- <core-slideshow>
    <core-slideshow-slide>This is slide number one</core-slideshow-slide>
    <core-slideshow-slide>This is slide number two</core-slideshow-slide>
    <core-slideshow-slide>This is slide number three</core-slideshow-slide>
    <core-slideshow-slide>This is slide number four</core-slideshow-slide>
</core-slideshow> -->
<p-carousel
    [value]="eventList"
    [numVisible]="2"
    [numScroll]="1"
    [circular]="true"
    [autoplayInterval]=" eventList.length > 2 ? 3000 : 0"
    [showIndicators]="eventList.length > 2"
    [showNavigators]="eventList.length > 2"
>
    <ng-template let-event  pTemplate="item">
        <div [routerLink]="'/events/' + event.eventLink" class="relative rounded-lg border-slate-200 dark:border-slate-500 border bg-slate-100 dark:bg-slate-700 text-lrpTicketBlack dark:text-stone-300 px-10 ms-3 me-4  py-6 cursor-pointer h-[700px]">
            @if (event.img) {
                <img [src]="event.img.promo" class="mb-6 mx-auto rounded-lg shadow-sm shadow-lrpTicketBlack" [alt]="event.name">
            }
            <p class="text-3xl font-bold tracking-wide text-center">{{ event.name }}</p>
            <p class="text-xs text-center" [innerText]="event.location"></p>
            <div class="text-center italic text-sm mt-3" [innerHTML]="event.promoDescription">

            </div>
            <div class="absolute bottom-3 flex justify-between w-full pe-10 left-5">
                <div>
                @if (event.eventHost.display){
                    <img [src]="event.eventHost.img.thumbnail" class="max-h-20 mix-blend-multiply" [alt]="event.name" [pTooltip]="event.eventHost.name">
                }
            </div>

                @if (event.eventHost.eventSystem.img) {
                    <img [src]="event.eventHost.eventSystem.img.url" class="object-contain w-44 mix-blend-multiply" [alt]="event.name">
                }
                @else {
                    <p class="font-semibold text-2xl italic text-gray-500">{{ event.eventHost.eventSystem.name }}</p>
                }
            </div>
        </div>
    </ng-template>
</p-carousel>